import { C, t } from '../constants/dashboardConstants';

const MENU_ITEMS = [
  {
    id: '계정설정',
    title: '계정 설정',
    subtitle: '제작자 정보, 비밀번호 관리',
    icon: (color) => (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="1.8"/>
        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    ),
  },
  // {
  //   id: '알림설정',
  //   title: '알림설정',
  //   subtitle: '푸시 알림, 이메일 알림 설정',
  //   icon: (color) => (
  //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
  //       <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
  //       <path d="M13.73 21a2 2 0 01-3.46 0" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
  //     </svg>
  //   ),
  // },
  // {
  //   id: '개인정보보호',
  //   title: '개인정보 보호',
  //   subtitle: '프로필 공개 범위, 데이터 관리',
  //   icon: (color) => (
  //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
  //       <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  //     </svg>
  //   ),
  // },
  // {
  //   id: '결제및구독',
  //   title: '결제 및 구독',
  //   subtitle: '결제 수단, 구독 관리',
  //   icon: (color) => (
  //     <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
  //       <rect x="2" y="5" width="20" height="14" rx="2" stroke={color} strokeWidth="1.8"/>
  //       <path d="M2 10h20" stroke={color} strokeWidth="1.8"/>
  //     </svg>
  //   ),
  // },
];

export default function SettingsMenu({ active, onSelect }) {
  return (
    <div style={{
      width: '345px', maxWidth: '100%', flexShrink: 0,
      background: C.white, border: `1px solid ${C.g200}`,
      borderRadius: '20px', boxShadow: C.shadow,
      overflow: 'hidden',
    }}>
      {MENU_ITEMS.map((item) => {
        const isActive = active === item.id;
        const iconColor = isActive ? C.white : C.g400;
        return (
          <div
            key={item.id}
            onClick={() => onSelect(item.id)}
            style={{
              display: 'flex', alignItems: 'center', gap: '14px',
              padding: '20px 18px', height: '77px', boxSizing: 'border-box',
              background: isActive ? C.bk : 'transparent',
              cursor: 'pointer',
            }}
          >
            <div style={{
              width: '36px', height: '36px', borderRadius: '10px', flexShrink: 0,
              background: isActive ? '#222222' : C.g200,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              {item.icon(iconColor)}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <span style={t('18px', 600, isActive ? C.white : C.bk)}>{item.title}</span>
              <span style={t('14px', 400, isActive ? '#A2A2A2' : C.sub)}>{item.subtitle}</span>
            </div>
          </div>
        );
      })}

      {/* 로그아웃 */}
      {/* <div style={{ borderTop: `1px solid ${C.g200}` }}>
        <div
          style={{
            display: 'flex', alignItems: 'center', gap: '14px',
            padding: '20px 18px', height: '77px', boxSizing: 'border-box',
            cursor: 'pointer',
          }}
        >
          <div style={{
            width: '36px', height: '36px', borderRadius: '10px', flexShrink: 0,
            background: C.g200,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" stroke={C.g400} strokeWidth="1.8" strokeLinecap="round"/>
              <polyline points="16 17 21 12 16 7" stroke={C.g400} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="21" y1="12" x2="9" y2="12" stroke={C.g400} strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </div>
          <span style={t('18px', 600, C.bk)}>로그아웃</span>
        </div>
      </div> */}
    </div>
  );
}
